import { render, staticRenderFns } from "./upload-files-popup.vue?vue&type=template&id=2efd4e5c&"
import script from "./upload-files-popup.vue?vue&type=script&lang=js&"
export * from "./upload-files-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports